var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from "mobx";
class State {
    constructor() {
        Object.defineProperty(this, "currentSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "playRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "playing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "duration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "mapScale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0.25
        });
        makeObservable(this);
    }
    incraseSeconds(seconds) {
        state.currentSeconds += seconds;
        if (state.currentSeconds >= this.duration)
            this.playing = false;
    }
    absoluteSeek(seconds) {
        state.currentSeconds = seconds;
    }
}
__decorate([
    observable
], State.prototype, "currentSeconds", void 0);
__decorate([
    observable
], State.prototype, "playRate", void 0);
__decorate([
    observable
], State.prototype, "playing", void 0);
__decorate([
    observable
], State.prototype, "duration", void 0);
__decorate([
    observable
], State.prototype, "mapScale", void 0);
__decorate([
    action
], State.prototype, "incraseSeconds", null);
__decorate([
    action
], State.prototype, "absoluteSeek", null);
export const state = new State();
let before = performance.now();
function loop() {
    requestAnimationFrame(loop);
    const now = performance.now();
    if (state.playing)
        state.incraseSeconds((now - before) / (1000 * state.playRate));
    before = now;
}
loop();
